import {
	IconButton, SvgIcon,
	Typography,
} from '@mui/material'
import type {
	JSX,
} from 'react'
import {
	memo,
	useMemo,
} from 'react'
import {
	useLocation,
	useNavigate,
} from 'react-router-dom'

import LeftIcon from '@/shared/assets/icons/chevron-left.svg?react'
import {
	AppRouterKeys,
} from '@/shared/model/constants'

import {
	getPageTitle,
	isMainPage,
} from '../../utils'
import {
	HStackPageHeader,
} from './page-header-base.styles'

export const PageHeaderBase = memo((): JSX.Element => {
	const location = useLocation()
	const navigate = useNavigate()

	const pageTitle = useMemo(() => {
		return getPageTitle(location.pathname)
	}, [location.pathname])

	const handleBack = (): void => {
		if (isMainPage(location.pathname)) {
			navigate(AppRouterKeys.HOME, {
				replace: true,
			})
		}
		else {
			navigate(-1)
		}
	}

	return (
		<HStackPageHeader
			alignItems='center'
			justifyContent='space-between'
		>
			<IconButton
				size='small'
				onClick={handleBack}
			>
				<SvgIcon>
					<LeftIcon />
				</SvgIcon>
			</IconButton>

			<Typography
				fontWeight={600}
				variant='body-small'
				sx={{
					position:      'absolute',
					left:          '50%',
					transform:     'translateX(-50%)',
					pointerEvents: 'none',
				}}
			>
				{pageTitle}
			</Typography>

			<div style={{
				width: '40px',
			}} />
		</HStackPageHeader>
	)
})

PageHeaderBase.displayName = 'PageHeaderBase'
